"use client";

import React from "react";
import { cn } from "@/lib/utils";

export interface ChipProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "success" | "warning" | "info";
  size?: "sm" | "md";
}

export const Chip = React.forwardRef<HTMLDivElement, ChipProps>(
  ({ className, variant = "default", size = "md", children, ...props }, ref) => {
    const variantClasses = {
      default: "bg-white/10 text-white border-white/20",
      success: "bg-green-500/20 text-green-300 border-green-500/30",
      warning: "bg-yellow-500/20 text-yellow-300 border-yellow-500/30",
      info: "bg-blue-500/20 text-blue-300 border-blue-500/30",
    };

    const sizeClasses = {
      sm: "px-2 py-1 text-xs",
      md: "px-3 py-1.5 text-sm",
    };

    return (
      <div
        ref={ref}
        className={cn(
          "inline-flex items-center rounded-full border",
          "backdrop-blur-sm font-medium",
          variantClasses[variant],
          sizeClasses[size],
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);
Chip.displayName = "Chip";

